import { render, staticRenderFns } from "./ElevateWellnessMemberShip.vue?vue&type=template&id=c42d3f2e&scoped=true"
import script from "./ElevateWellnessMemberShip.vue?vue&type=script&lang=js"
export * from "./ElevateWellnessMemberShip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42d3f2e",
  null
  
)

export default component.exports